import React from 'react'
import PropTypes from 'prop-types'
import styles from './ListSlatePlugin.scss'

const ListNumberedNode = ({ attributes, children }) => (
  <ol {...attributes} className={styles.ListNode}>
    {children}
  </ol>
)

ListNumberedNode.propTypes = {
  attributes: PropTypes.object,
  children: PropTypes.node
}

export default ListNumberedNode



// WEBPACK FOOTER //
// ./src/components/ListSlatePlugin/ListNumberedNode.js